module.exports = __webpack_public_path__ + "img/sbh1.bf676c7c.jpg";